export const getClientVersion = (state) => state.appUpdate.clientVersion;
